import React from 'react';

import Avatar from '@atlaskit/avatar';
import { cssMap, cx } from '@atlaskit/css';
import { Inline, Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { UnitSwitcherItemProps } from './types';

const styles = cssMap({
	switcherItem: {
		backgroundColor: token('elevation.surface.overlay'),
		'&:hover': {
			backgroundColor: token('color.background.neutral.hovered'),
			textDecoration: 'none',
		},
	},
	switcherItemSelected: {
		backgroundColor: token('color.background.selected'),
		'&:hover': {
			backgroundColor: token('color.background.selected.hovered'),
			textDecoration: 'none',
		},
	},
	switcherItemContainer: {
		borderRadius: token('radius.large'),
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
	},
});

export const UnitSwitcherItem = (props: UnitSwitcherItemProps): React.JSX.Element => {
	const { name, isSelectedUnit, onClick } = props;
	return (
		<Pressable
			xcss={cx(
				styles.switcherItemContainer,
				isSelectedUnit ? styles.switcherItemSelected : styles.switcherItem,
			)}
			onClick={onClick}
		>
			<Inline alignBlock="center" space="space.100">
				<Avatar size="small" appearance="square" />
				<Text color={isSelectedUnit ? 'color.text.selected' : 'color.text'}>{name}</Text>
			</Inline>
		</Pressable>
	);
};
